// Read-side contracts mirroring Sierra.Inventory.Models kardex audit DTOs (v1.1.22).

import { ResponseTranslation } from '../translation/Translations';

/**
 * Full transaction type enum for kardex filtering. The legacy InventoryTransactionType
 * in models/inventory/inventory-transaction.ts only has 4 values and is left untouched.
 */
export enum KardexTransactionType {
  Transfer,
  Receipt,
  Adjustment,
  Consumption,
  InternalReturn,
  ProviderReturn,
  InternalTransfer,
  InitialLoad,
}

export enum KardexLineItemType {
  LotItem,
  Roll,
  Chemical,
}

export interface KardexTransactionSearchCommand {
  fromDate?: string; // UTC ISO — optional; searches are not date-bound when omitted
  toDate?: string; // UTC ISO — optional
  itemCode?: string;
  transactionTypes?: number[];
  statuses?: number[];
  locationCodePrefix?: string;
  lotItemNumber?: string;
  productionCardNumber?: string;
  location?: string; // location code (e.g. "NT.WA-BATCHING-1") or full name (e.g. "Batching")
}

export interface KardexTransaction {
  transactionId: string;
  movementDate: string | null;
  transactionType: number;
  status: number;
  movementDescription: string;
  documentNumber: string;
  documentType: string;
  fromLocationCode: string | null;
  toLocationCode: string | null;
  fromLocationName: ResponseTranslation | null;
  toLocationName: ResponseTranslation | null;
  lineCount: number;
  totalQuantity: number;
  lines: KardexTransactionLine[];
}

export interface KardexTransactionLine {
  number: string;
  lineItemType: number;
  itemCode?: string;
  quantity: number;
  uom: number;
  fromLocationCode: string | null;
  toLocationCode: string | null;
  fromLocationName: ResponseTranslation | null;
  toLocationName: ResponseTranslation | null;
  productionCardNumber: string | null;
}

export interface KardexTransactionSearchResult {
  items: KardexTransaction[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface KardexRollHistory {
  rollNumber: string;
  transactions: KardexRollTransaction[];
}

export interface KardexRollTransaction {
  transactionId: string;
  quantity: number;
  movementDate: string | null;
  movementDescription: string;
  documentNumber: string;
  documentType: string;
  productionCardNumber: string | null;
  transferUnitNumber: string | null;
  fromLocationCode: string | null;
  toLocationCode: string | null;
  fromLocationName: ResponseTranslation | null;
  toLocationName: ResponseTranslation | null;
  transactionStatus: number;
}
